export default {
    en: {
        id: 'exercise3',
        title: 'We can eliminate losses in the Board Mill Operation',
        titles: ['Find cheaper supplies of waste paper', 'Cut the cost of board product', 'Close one of the solid case factories'],
        boxes: [
            {
                name: 'box1',
                title: 'Time',
            },
            {
                name: 'box2',
                title: 'Structure',
            },
            {
                name: 'box3',
                title: 'Degree',
            }
        ],
        correctAnswers: {
            box1: false,
            box2: true,
            box3: false
        },
        userAnswers: {
            box1: false,
            box2: false,
            box3: false
        },
        text: 'The Board Mill operation consists of three waste paper plants, two board production plants, and four solid case factories. The order of the actions reflects the visualization of this structure. The fact that the structure shows the operations in process order is not relevant. The ideas are not in time order, nor in degree order, but in the order in which they appear on the structure.'
    }
}


// WEBPACK FOOTER //
// ./client/app/modules/courses/6/identifyingLogicaOrder/i18n/exercise3.js